import { createSelector } from '@ngrx/store';
import { getOneClickState } from '../reducers';

export const getOneClickShippingLocationModeState = createSelector(
  getOneClickState,
  state => state.shippingLocationModes,
);

export const getOneClickShippingLocationModes = createSelector(
  getOneClickShippingLocationModeState,
  state => state.shippingLocationModesAvailable,
);

export const getOneClickShippingLocationModeSelected = createSelector(
  getOneClickShippingLocationModeState,
  state => state.selected,
);
